const messages = {
  text: 'Need some help? Write us a mail to ',
  email: 'contact@welovemoons.com'
}

export default messages
